export default __webpack_public_path__ + "static/media/istockphoto-998313080-612x612.9421325d.jpg";